// extracted by mini-css-extract-plugin
export default {"rating":"yH-z","numberOfStars":"zH-z","count":"AH-z","barGraphSpacing":"BH-z","barGraph":"CH-z"};